import TagManager from '@sooro-io/react-gtm-module';

export function gtmPushAndWait(data: object, timeout = 2000): Promise<void> {
  return new Promise<void>((resolve) => {
    const win = window as unknown as {
      dataLayer?: Array<Record<string, object>>;
      google_tag_manager?: Record<string, unknown>;
    };

    const hasGtm =
      typeof window !== 'undefined' && Array.isArray(win.dataLayer) && typeof win.google_tag_manager === 'object';
    if (!hasGtm) {
      console.warn('[GTM] Not available — falling back to timeout');
      resolve();
      return;
    }

    const fallback = setTimeout(() => {
      resolve();
    }, timeout);

    TagManager.dataLayer({
      dataLayer: {
        ...data,
        eventCallback: () => {
          clearTimeout(fallback);
          resolve();
        },
        eventTimeout: timeout,
      },
    });
  });
}
